export default function isWithUnderscoreWithoutSpaces(str: string): boolean {
  return !/^[a-zA-Z0-9_]+$/g.test(str);
}
